/** 施工日历按洛杉矶墙上时间排布。日期用 UTC 做纯日历加减，避免浏览器时区或夏令时改变日期。
 * 接口保留按月鉴权和查询；跨月周历合并两个月的结果，同一安排只计一次。
 */
import { fmtD, fmtRange } from "../../lib/date";
/** 100% 只代表报工完成，计划任务须显示待验收；不改变旧日程的状态枚举。 */
export const planStatusLabel = (task, zh) => task.isPlan ? (zh ? '计划 · 未派工' : 'Draft · Unassigned') :
  task.constructionPlanKey && task.status === 'completed' ? (task.planAccepted ? (zh ? '已验收' : 'Accepted') : (zh ? '100% · 待验收' : '100% · Awaiting acceptance')) : '';
export const shiftDay = (day, offset) => {
  const [y, m, d] = day.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + offset)).toISOString().slice(0, 10);
};
export const weekDays = (day) => {
  const weekday = new Date(`${day}T12:00:00Z`).getUTCDay();
  const monday = shiftDay(day, -((weekday + 6) % 7));
  return Array.from({ length: 7 }, (_, i) => shiftDay(monday, i));
};
// 午夜是结束边界，不把周日夜间完工的任务算进下周一。
export const lastWorkDay = (task) => task.endAt.slice(11, 16) === "00:00" ? shiftDay(task.endAt.slice(0, 10), -1) : task.endAt.slice(0, 10);
// 自动排程按项目工作日显示；历史手工安排没有 workdays 时仍按连续日期兼容。
export const taskOnDay = (task, day) => task.startAt.slice(0, 10) <= day && lastWorkDay(task) >= day
  && (!task.workdays || task.workdays.includes((new Date(`${day}T12:00:00Z`).getUTCDay() + 6) % 7));

/** 对外只显示施工日期，午夜结束换算成前一天，防止用户把接口结束边界误读成多做一天。 */
export const scheduleDateRange = (startAt, endAt) => {
  if (!startAt || !endAt) return "";
  const start = startAt.slice(0, 10), finish = lastWorkDay({ endAt });
  return start === finish ? fmtD(start) : fmtRange(start, finish);
};

/** 日期表单使用包含完工当天的工期，接口仍沿用左闭右开时间区间，避免工人页面漏掉最后一天。
 * 未调整日期的旧任务保留原始时间，编辑文字/工种时不触发改期，也不会绕过待审批时间锁。
 */
export function scheduleDateValues(start, finish, original) {
  if (original && start === original.startAt.slice(0, 10) && finish === lastWorkDay(original)) {
    return { startAt: original.startAt, endAt: original.endAt };
  }
  return { startAt: `${start}T00:00`, endAt: `${shiftDay(finish, 1)}T00:00` };
}

/** 合并跨月数据时按稳定 ID 去重；并发请求碰上编辑时保留较新任务版本。 */
export function mergeScheduleMonths(responses) {
  const unique = (field) => {
    const rows = new Map();
    responses.forEach((data) => (data[field] || []).forEach((row) => {
      if (!rows.has(row.id) || (row.version || 0) >= (rows.get(row.id).version || 0)) rows.set(row.id, row);
    }));
    return Array.from(rows.values());
  };
  return { ...responses[0], tasks: unique("tasks").sort((a, b) => a.startAt.localeCompare(b.startAt)), events: unique("events"), todos: unique("todos") };
}
